<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MWB"][isEdit? "EMWB": "AMWB"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="min-height: 250px;">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MWB"]["BRN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_mwb['AGIT']"
                                                        @input="AgentGroupChange"
                                                        :disabled="isEdit"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BRN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MWB"]["PM"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_pm"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('MWB.PM')"
                                                        v-model="obj_mwb['PM']"
                                                        :disabled="isEdit"
                                                        ref="PM" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PM','PM') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["CI"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadSearchMemberCurrencyOptions"
                                                        :options="ddSearchMemberCurrencyList"
                                                        :auto-load-root-options="false"
                                                        :disable-branch-nodes="true"
                                                        :disabled="isEdit"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                        v-model="obj_mwb['CI']" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['MWB']['WBL']}}<span class="required" /> :</label>
                                            <CButton size="sm" color="outline-info" style="float: right;" @click="addBank()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                                            <CRow style="padding-top: 20px; margin-left:1px; width: 100%;">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 60px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['MWB']['CC']}}</th>
                                                            <th>{{this.getLanguage['MWB']['BN']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_mwb.BankList == 0 || !obj_mwb.BankList">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_mwb.BankList">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ ConvertCountryCode(data.CC) }}</td>
                                                        <td>{{ data.BN }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                            <span class="ErrMsg">{{ ValidationErrMsg('BankList','WBL') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMWB()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="checkModuleAccess2(constAccessType.add) && bool_isABA">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MWB"]["WBL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddBank()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6" class="form-group">
                                        <label class="col-form-label-sm">{{this.getLanguage["BAL"]["CC"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_cc"
                                                    :clearable="false"
                                                    v-model="obj_bank['CC']"
                                                    :flat="true"
                                                    :defaultExpandLevel="Infinity"
                                                    @input="CountryCodeChange"
                                                    ref="CC" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('CC','CC') }}</span>

                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["BAL"]["BN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bank"
                                                    v-model="obj_bank['BI']"
                                                    ref="BI" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BI','BN') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["MWB"]["MWB"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addMWB()"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AN"] }}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel">{{this.getLanguage["MT"]["BN"]}} :</label>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MWB"]["PM"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_pm"
                                            :placeholder="this.utilGetDDLanguage('MWB.PM')"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadSearchMemberCurrencyOptions"
                                            :options="ddSearchMemberCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="str_FV[2].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["MWB"]["MWBL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["MWB"]["BRN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["C"]}}<i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["PM"]}}<i @click="setSortTable('PM')" :class="setSortLogo('PM')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["WBL"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["MWB"]["BRN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["C"]}}<i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["PM"]}}<i @click="setSortTable('PM')" :class="setSortLogo('PM')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MWB"]["WBL"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_mwbl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_mwbl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" @click="removeMWB(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editMWB(data.AGI, data.PM, data.CI)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.GN }} ({{ data.PC }})</td>
                            <td>
                                <span v-if="data.CI > 0">{{ data.ISOC }}</span>
                                <span v-else>{{getLanguage["GL"]["ALL2"]}}</span>
                            </td>
                            <td>{{ renderPaymentMethod(data.PM) }}</td>
                            <td><span class="grid-line" v-for="bn in data.BankList">{{ bn.BN }}</span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import { constAccessType, constCountryCode, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        props: {

        },
        data() {
            return {
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_CV: false, // Check Validation
                bool_bankCV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_isABA: false, // Add Bank Modal Visible
                bool_showSearchBar: true,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                str_tableSortBy: "AGI", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "PM" }, { F: "CI" }], //Filter Value
                obj_mwb: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: "",
                    AGIT: null,
                    BankList: [],
                    PM: null,
                    CI: null,
                },
                obj_bank: {
                    CC: null,
                    BN: null,
                    BI: null,
                    CI: null,
                },
                arry_mwbl: [],
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_bank: [],//bank option
                constAccessType: constAccessType,
                isEdit: false,
                dd_pm: [],
                ddSearchMemberCurrencyList: null,
                searchAgi: null
            }
        },
        validations: {
            obj_bank: {
                CC: { required },
                BI: { required },
            },
            obj_mwb: {
                AGIT: { required },
                PM: { required },
                BankList: { required },
            }
        },
        created() {
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.MWB';
            this.getPMList();
            this.getAgentGroup();
            this.getCountryCode();
            this.getMWBList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MWB', 'B', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeAddBank() {
                this.dd_bank = [];
                this.bool_isABA = !this.bool_isABA;
                this.bool_bankCV = false;
                this.obj_bank = {
                    CC: null,
                    BN: null,
                    BI: null,
                    CI: null,
                };

            },
            addBank() {
                this.bool_isABA = true;
                this.dd_bank = [];
            },
            saveBank() {
                this.bool_bankCV = true;
                this.$v.obj_bank.$touch();
                if (!this.$v.obj_bank.$error) {
                    var exist = false;
                    if (!this.obj_mwb.BankList) {
                        this.obj_mwb.BankList = [];
                    }

                    for (var pt of this.dd_bank) {
                        if (pt.id == this.obj_bank['BI']) {
                            this.obj_bank['BN'] = pt.label;
                            this.obj_bank['CI'] = this.obj_mwb['CI'];
                        }
                    }

                    for (var i = 0; i < this.obj_mwb.BankList.length; i++) {
                        if (this.obj_mwb.BankList[i].BI == this.obj_bank.BI) {
                            this.obj_mwb.BankList[i] = this.obj_bank;
                            exist = true;
                            break;
                        }
                    }
                    if (!exist) {
                        this.obj_mwb.BankList.push(this.obj_bank);
                    }
                    this.bool_isABA = false;
                    this.bool_bankCV = false;
                    this.obj_bank = {};
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_bank"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeBank(index) {
                this.$delete(this.obj_mwb.BankList, index);
                this.$forceUpdate();
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMWBList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMWBList();
                }
            },
            getCountryCode() {
                this.dd_cc = constCountryCode;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    this.str_FV[0].FV = value.split("-")[1];
                    this.searchPAgi = this.str_FV[0].FV;
                    this.ddSearchMemberCurrencyList = null;
                }
                else {
                    this.str_FV[0].FV = null;
                    this.searchPAgi = 0;
                    this.str_FV[2].FV = null;
                    this.ddSearchMemberCurrencyList = null;
                }
            },
            AgentGroupChange(value) {
                if (value != undefined) {
                    this.searchAgi = value.split("-")[1];
                    this.searchPAgi = this.searchAgi;
                }
                else {
                    this.obj_mwb['AGIT'] = null;
                    this.searchPAgi = 0;
                    this.obj_mwb['CI'] = null;
                }

                var agi = 0;
                var that = this;
                if (value) {
                    agi = value.split("-")[1];
                }
                this.getDataApi(`/api/dd/cur/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                            if (that.ddSearchMemberCurrencyList.length == 1) {
                                that.obj_mwb['CI'] = that.ddSearchMemberCurrencyList[0].id;
                            } else {
                                that.obj_mwb['CI'] = null;
                            }
                        }
                        else {
                            that.ddSearchMemberCurrencyList = null;
                        }
                    });
            },
            CountryCodeChange(value) {
                var that = this;
                var cc = value;
                this.getDataApi(`/api/dd/allbank/` + cc,
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist
                        }
                    });
            },
            loadSearchMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.searchPAgi) {
                    this.searchPAgi = 0;
                }

                this.getDataApi(`/api/dd/cur/${this.searchPAgi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                        }
                        else {
                            that.ddSearchMemberCurrencyList = null;
                        }
                        callback();
                    });
            },
            getMWBList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        path += ("&f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                    }
                };

                this.getDataApi(`/api/memwithbank/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMWBList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setMWBList(data) {
                this.arry_mwbl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setMWB(data) {
                this.obj_mwb.BankList = [];
                this.obj_mwb.PM = data[0].PM;
                this.obj_mwb.AGI = data[0].AGI;
                var that = this;
                this.getDataApi(`/api/dd/cur/${this.obj_mwb.AGI}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                        }
                        else {
                            that.ddSearchMemberCurrencyList = null;
                        }
                    });

                if (data[0].CI > 0) {
                    this.obj_mwb.CI = data[0].CI;
                } else {
                    this.obj_mwb.CI = null;
                }

                if (this.obj_mwb.AGI != 0) {
                    this.obj_mwb.AGIT = "3-" + this.obj_mwb.AGI;
                }
                var temp_BankList = [];
                var temp_obj_bank = {
                    CC: null,
                    BN: null,
                    BI: null,
                    CI: null,
                };

                for (var i = 0; i < data.length; i++) {

                    temp_obj_bank.CC = data[i].CC;
                    temp_obj_bank.BN = data[i].BN;
                    temp_obj_bank.BI = data[i].I;
                    temp_obj_bank.CI = data[i].CI;

                    temp_BankList.push(temp_obj_bank);

                    temp_obj_bank = {
                        CC: null,
                        BN: null,
                        BI: null,
                        CI: null,
                    };
                }


                this.obj_mwb.BankList = Object.assign(this.obj_mwb.BankList, temp_BankList);
                this.bool_isAMV = true;
            },
            addMWB() {
                this.obj_mwb = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: "",
                    AGIT: null,
                    BankList: [],
                    PM: null,
                    CI: null,
                };
                this.dd_bank = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.isEdit = false;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_mwb.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_mwb.AGIT);
                    }
                }
            },
            ValidationBankErrMsg(value, langKey = "") {
                if (this.bool_bankCV) {
                    var validateObj = this.$v.obj_bank[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MWB"][langKey]);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {
                    var validateObj = this.$v.obj_mwb[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MWB"][langKey]);
                    }
                }

            },
            saveMWB() {
                this.bool_CV = true;
                this.obj_mwb['RS'] = 2;

                if (this.obj_mwb.AGIT != null && this.obj_mwb.AGIT.length > 0) {

                    var agi = this.obj_mwb.AGIT.split("-");
                    this.obj_mwb.AGI = agi[1];
                }

                this.$v.obj_mwb.$touch();
                if (!this.$v.obj_mwb.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/memwithbank/s`, this.obj_mwb,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                if (that.isEdit) {
                                    that.isEdit = false;
                                }
                                that.getMWBList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_mwb"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editMWB(agi, pm, ci) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/memwithbank/g/${agi}/${pm}/${ci}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMWB(d);
                            that.isEdit = true;
                        }
                    });
            },
            removeMWB(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            agi: data.AGI,
                            pm: data.PM,
                            uts: data.UTS,
                            ci: data.CI
                        };

                        this.postDataApi(`/api/memwithbank/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getMWBList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;
                this.getMWBList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ConvertCountryCode(value) {
                var text = '';
                for (var i = 0; i < this.dd_cc.length; i++) {
                    for (var x = 0; x < this.dd_cc[i].children.length; x++) {
                        if (this.dd_cc[i].children[x].id == value) {
                            text = this.dd_cc[i].children[x].label;
                        }
                    }
                }
                return text;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getPMList() {
                this.dd_pm = [{ id: '1', label: this.getLanguage['MWB']['PM1'] }, { id: '2', label: this.getLanguage['MWB']['PM2'] }];
            },
            renderPaymentMethod(pm) {
                if (pm > 0)
                    return this.getLanguage['MWB']['PM' + pm];
                else
                    return '-';
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMWBList();
            },
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Banks/MemberWithdrawalBank.vue